import React from 'react';

export default function Topbar({ title, subtitle, actions }) {
  return (
    <header className="topbar">
      <div>
        <h1 className="topbar-title">{title}</h1>
        {subtitle && <p className="topbar-sub">{subtitle}</p>}
      </div>
      <div className="topbar-actions">{actions}</div>
    </header>
  );
}

export function StatCard({ label, value, accent, icon: Icon, loading }) {
  const style = accent ? { '--stat-accent': accent } : undefined;
  return (
    <div className="stat-card" style={style}>
      <div className="stat-card-top">
        <div className="stat-label">{label}</div>
        {Icon && <span className="stat-ico"><Icon /></span>}
      </div>
      {loading ? (
        <div className="skeleton skeleton-stat" />
      ) : (
        <div className="stat-value">{value}</div>
      )}
    </div>
  );
}

export function Skeleton({ width, height, style }) {
  return <span className="skeleton" style={{ width, height, ...style }} />;
}

export function Badge({ children, tone = 'default' }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function DataTable({ columns, rows, keyField = 'id', emptyMessage = 'No records yet.', loading, skeletonRows = 5 }) {
  if (loading) {
    return (
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>{columns.map((c) => <th key={c.key}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {Array.from({ length: skeletonRows }).map((_, i) => (
              <tr key={`sk-${i}`}>
                {columns.map((c) => (
                  <td key={c.key}><span className="skeleton skeleton-text" style={{ width: `${55 + ((i * 7 + c.key.length * 5) % 40)}%` }} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  if (!rows?.length) {
    return <p className="hint table-empty">{emptyMessage}</p>;
  }
  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.key}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row[keyField] || row.ipid || row.id}>
              {columns.map((c) => (
                <td key={c.key}>{c.render ? c.render(row) : row[c.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function PageShell({ title, subtitle, actions, children }) {
  return (
    <div className="page">
      <Topbar title={title} subtitle={subtitle} actions={actions} />
      <div className="page-body">{children}</div>
    </div>
  );
}
